import React, { useState,useEffect,useContext } from 'react';
import {Redirect, useLocation} from "react-router-dom";
import UserContext from "../../Context/AppContext";
import realtimeDB from "../../Utils/api";
import SkeletonCostumers from "../../Components/Lista/SkeletonCostumers";
import CostumerList from "../../Components/Lista/CostumerList";
import SwitchState from '../../Components/Lista/SwitchState';
import InfoCostumers from '../../Components/Lista/InfoCostumers';
import AddCostumer from '../../Components/Lista/AddCostumer';
import HeaderAdmin from '../../Components/HeaderAdmin';
import styled from "styled-components";import usePrivilegios from '../../Hooks/usePrivilegios';
;

const ContainerList=styled.div`
display:grid;
grid-template-columns: auto ;
grid-template-rows: 1fr;`;


const Header=styled.div`
margin-bottom:20px;
display:grid;
grid-template-rows:1fr;
grid-template-columns:50% 50%;
@media screen and (max-width:440px)
{
    grid-template-columns:100%;
    justify-items:center;
}`;

const ContainerContent=styled.div`
margin:10px;`;

const ListaAdmin  =()=> 
{
    usePrivilegios();
    const {user}=useContext(UserContext);
    const [Loading, setLoading] = useState(true);
    const [Customers, setCustomers] = useState([]);
    const [CustomersDouble, setCustomersDouble] = useState([]);
    const [CustomersFourfold, setCustomersFourfold] = useState([]);
    const [TotalDiners, setTotalDiners] = useState(undefined);
    const [TotalPartys, setTotalPartys] = useState(0);
    const [Error, setError] = useState(undefined);
  

    const fetchData=()=>
    {

        realtimeDB.ref("/Customers").on("value",(snapshot) =>
        {
            var customers = [];
            var double=[];
            var fourfold=[];
            var totalDiners=0;
            var totalPartys=0;

            snapshot.forEach((customer) => 
            {
                if(customer.val().status!=="no-info" && customer.val().status!=="cancelled" && customer.val().status!=="served")
                {
                    
                    totalDiners+= parseInt(customer.val().dinersCount);
                    totalPartys+=1;
                }

                if(customer.val().status!=="cancelled" && customer.val().status!=="served")
                {
                    customers.push({id:customer.key,data:customer.val()});
                }
            });
                
            customers = customers.sort((a, b) => (a.data.date > b.data.date ) ? 1 : (a.data.date  === b.data.date ) ? ((a.data.date  > b.data.date ) ? 1 : -1) : -1);
              
            customers.map(customer =>
            {
                if(customer.data.dinersCount<=2) 
                {
                    double.push(customer);
                }
                else
                {
                    fourfold.push(customer);
                }
            });
            setCustomers(customers);
            setCustomersDouble(double);
            setCustomersFourfold(fourfold);
            setTotalDiners(totalDiners);
            setTotalPartys(totalPartys);

            setLoading(false);
        });
    }

    useEffect(() => 
    {
        document.title=`Baum Lanús - Lista de Espera`;
        window.document.getElementById("favicon").href="https://i.pinimg.com/originals/b5/cb/ac/b5cbac8fd0f87d2d08b490bdd82b597d.png";
        fetchData();
        
      
    }, [])

    if(Error)
    {
        return <Redirect to={`/login`} /> 
    }

    if(Loading)
    {
        return <SkeletonCostumers/>
    }
    else
    {
        window.document.title=`(${TotalPartys}) Lista de Espera`;

        return <ContainerList>  
                <HeaderAdmin title={"Lista de espera"}/>
                <ContainerContent>
                    <Header>
                        <InfoCostumers/>
                        <SwitchState/>
                    </Header>
                    <CostumerList  user={user}  costumers={Customers} CustomersDouble={CustomersDouble} CustomersFourfold={CustomersFourfold}/>
                    <div style={{height:"100px"}}></div>
                    <AddCostumer/>
                </ContainerContent>
            </ContainerList>
    }
    
}

export default ListaAdmin;